<div class="employee">
  <h2 class="employee__title" (click)="navigateToEmployees()">Employees</h2>
  <i class="icon-arrow"></i>
  <span class="employee__current">{{ currentName }}</span>
</div>

<div class="tab-list">
  <app-tab-list>
    <app-tab url="general" tabTitle="General"> </app-tab>
    <app-tab url="personal-data" tabTitle="Personal Data" *ngIf="isAbleToView">
    </app-tab>
    <app-tab
      url="personal-recruiter"
      tabTitle="Personal Data"
      *ngIf="isRecruiterAccess"
    ></app-tab>
    <app-tab
      url="professional-data"
      tabTitle="Professional"
      *ngIf="isAbleToView"
    >
    </app-tab>
    <app-tab url="hr-data" tabTitle="HR data" *ngIf="isHRDataAccess"> </app-tab>
    <app-tab
      url="salary-extended"
      tabTitle="Salary"
      *ngIf="isSalaryExtendedAccess"
    >
    </app-tab>
    <app-tab url="salary" tabTitle="Salary" *ngIf="isHRManager"> </app-tab>
    <app-tab
      url="salary-recruiter"
      tabTitle="Salary"
      *ngIf="isSalaryRecruiterAccess"
    ></app-tab>
    <app-tab url="pe" tabTitle="PE" *ngIf="isAccountantAccess"> </app-tab>
    <app-tab url="bank-info" tabTitle="Bank info" *ngIf="isAccountantAccess">
    </app-tab>
    <app-tab url="bcoin" tabTitle="B-coins" *ngIf="isBcoinAccess"> </app-tab>
  </app-tab-list>
</div>
